import angular from 'angular';
import tcPhoneNumberComponent from './tc-phone-number.component';
import editablePhoneDirective from './editable-phone.directive';

let tcPhoneNumberModule = angular.module('tcPhoneNumber', [])
  .component('tcPhoneNumber', tcPhoneNumberComponent)
  .directive('editablePhone', editablePhoneDirective);

export default tcPhoneNumberModule;




// WEBPACK FOOTER //
// ./client/common/directives/phone-number/tc-phone-number.js